<template>
  <div>
    <Breadcrumb :style="{margin: '24px 0'}">
        <BreadcrumbItem>首页</BreadcrumbItem>
        <BreadcrumbItem>网站设置</BreadcrumbItem>
        <BreadcrumbItem>水印设置</BreadcrumbItem>
    </Breadcrumb>
    <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
      <div class="head_style">
        <h2>水印设置</h2>
      </div>

      <div>
        <p ><b>水印图片</b></p>
        <div>
          <img :src="websiteinfo.water" style="width: 500px" id="web_favicon" >
        </div>
        <Upload action="/admin/Website/uploadWater" name="image" :on-success="handleSuccess" :show-upload-list="false">
            <Button icon="ios-cloud-upload-outline" id="ghost" >文件上传</Button>
        </Upload>
      </div><br><br>

      <div>
        <p ><b>透明度</b></p>
        <Input  placeholder="请输入透明度0-100" class="input-width" v-model="websiteinfo.opaque"></Input>
      </div><br>

      <div>
        <p ><b>是否开启水印</b></p>
        <RadioGroup v-model="websiteinfo.addto">
            <Radio :label = "1" >开启</Radio>
            <Radio :label = "0" >不开启</Radio>
        </RadioGroup>
      </div><br><br>

      <div class="button_style">
        <Button type="success" @click="webSitePutData()">提交</Button>
      </div><br>
    </Content>
  </div>
</template>
<style scoped>
* {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
p {
  line-height: 30px;
}
.head_style {
  height: 50px;
}
.img_style{
  height:200px;
}
.input-width{
  width: 700px;
}


</style>
<script>
import watermark from '@/assets/js/views/bak/watermark';

export default {
  ...watermark,
};
</script>

